import { useState, useEffect } from 'react';
import loader from '../common/loader.gif';
import SnackbarAlert from '../common/SnackbarAlert';
import {
  Divider,
  Card,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Typography,
  Grid,
  Container,
  CardHeader,
  CardContent,
  Button
} from '@mui/material';
import TextField from '@mui/material/TextField';
import request from '../../utils/request';
import { checkPermission } from '../../utils/permission';
import NoPermissionContent from '../common/NoPermissionContent';
import { LoadingButton } from '@mui/lab';

function CreatEdit({ closeCreateEditForm, editProdComDatas, editStatus }) {
  const [showSnackBarAlert, setShowSnackBarAlert] = useState({
    status: false,
    type: 'success',
    message: null
  });
  const [isLoading, setLoading] = useState(true);
  const [productClauses, setProductClauses] = useState<any>([]);
  const [status, setStatus] = useState(true);
  const [PolicyBrokerageConfigPermission, setPolicyBrokerageConfigPermission] =
    useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);

  useEffect(() => {
    checkBrokerageConfigPermission();
  }, []);

  const checkBrokerageConfigPermission = async () => {
    await checkPermission(
      'brokerageCalculation',
      'brokerageConfigurations'
    ).then((permission) => {
      setPolicyBrokerageConfigPermission(permission);
    });
  };

  useEffect(() => {
    getProductClauses();
  }, []);
  const getProductClauses = async () => {
    // setCheckedClauses([]);
    setLoading(true);
    request({
      url: 'policyProduct/getProductClauseClauseList',
      method: 'post',
      data: {
        productId: parseInt(editProdComDatas.product?.id),
        companyId: parseInt(editProdComDatas.company?.id)
      }
    }).then(
      (response) => {
        //Setting saved clause details for update
        if (response.status) {
          response['clasues'].forEach((clause) => {
            // clause.insurenceClause.rules = clause.rules;
            // clause.brokerageConfig = [];
            if (clause.brokerageConfigurations == null) {
              clause.brokerageConfigurations = {
                brokeragePercentage: null,
                minAmount: null,
                maxAmount: null
              };
            }
          });
          setProductClauses(response['clasues']);
          setLoading(false);
          setStatus(!status);
        } else {
          setShowSnackBarAlert({
            status: true,
            type: 'error',
            message: 'Something went wrong.Please try again.'
          });
        }
        setLoading(false);
      },
      (error) => {
        console.log(error);
        setLoading(false);
      }
    );
  };

  const saveBrokerage = () => {
    setLoading(true);
    setButtonLoader(true);
    const method = 'POST';
    let prodCmpBrokerageId = editProdComDatas.id;
    let companyId = editProdComDatas.company?.id;
    let productId = editProdComDatas.product?.id;
    request({
      url: 'productCompanyConfiguration/createProductClause',
      method: method,
      data: {
        prodCmpBrokerageId: prodCmpBrokerageId,
        companyId: companyId,
        productId: productId,
        productClauses: productClauses
      }
    })
      .then((data) => {
        closeCreateEditForm(true);
        setLoading(false);
        setButtonLoader(false);
      })
      .catch(function (err) {
        setShowSnackBarAlert({
          status: true,
          type: 'error',
          message: err.message
        });
        setButtonLoader(false);
        setLoading(false);
      });
  };

  const setbrokeragePercent = (event, index) => {
    productClauses[index].brokerageConfigurations.brokeragePercentage = event;
    setProductClauses(productClauses);
    setStatus(!status);
  };

  const setbrokerageMaxAmount = (event, index) => {
    productClauses[index].brokerageConfigurations.maxAmount = event;
    setProductClauses(productClauses);
    setStatus(!status);
  };

  const setbrokerageMinAmount = (event, index) => {
    productClauses[index].brokerageConfigurations.minAmount = event;
    setProductClauses(productClauses);
    setStatus(!status);
  };

  const handleSnackbarClose = () => {
    setShowSnackBarAlert({ status: false, type: null, message: null });
  };

  return (
    <>
      <Container maxWidth="lg">
        <SnackbarAlert
          showSnackBarAlert={showSnackBarAlert}
          handleSnackbarClose={handleSnackbarClose}
        />
        {PolicyBrokerageConfigPermission ? (
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="stretch"
            spacing={3}
          >
            <Grid item xs={12}>
              <Card>
                {editStatus ? (
                  <CardHeader title="Update Brokerage" />
                ) : (
                  <CardHeader title="Create Brokerage" />
                )}
                <Divider />

                <CardContent>
                  <Divider />
                  {isLoading ? (
                    <TableContainer>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell align="center">
                              <img
                                alt="loader"
                                src={loader}
                                className="loader"
                                width={100}
                                height={100}
                              />
                            </TableCell>
                          </TableRow>
                        </TableHead>
                      </Table>
                    </TableContainer>
                  ) : (
                    <TableContainer>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell>Coverages</TableCell>
                            <TableCell>Brokerage %</TableCell>
                            <TableCell>Min Amount</TableCell>
                            <TableCell>Max Amount</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {productClauses.map((clause, index) => {
                            return (
                              // <form key={clause.id} id={clause.id} onSubmit={formik.handleSubmit}>
                              <TableRow hover key={clause.id}>
                                <TableCell>
                                  <Typography
                                    variant="body1"
                                    fontWeight="bold"
                                    color="text.primary"
                                    gutterBottom
                                    noWrap
                                  ></Typography>
                                  {clause?.insurenceClause?.title}
                                </TableCell>
                                <TableCell>
                                  <TextField
                                    label="Brokerage"
                                    sx={{ width: '100%' }}
                                    size="small"
                                    name="brokeragePercentage"
                                    type="number"
                                    value={
                                      clause.brokerageConfigurations
                                        .brokeragePercentage
                                    }
                                    onChange={(event) => {
                                      var value = parseInt(
                                        event.target.value,
                                        10
                                      );
                                      if (value > 100) value = 100;
                                      if (value < 0) value = 0;
                                      setbrokeragePercent(
                                        isNaN(value) ? null : value,
                                        index
                                      );
                                    }}
                                  />
                                </TableCell>

                                <TableCell>
                                  <TextField
                                    label="Min Amount"
                                    sx={{ width: '100%' }}
                                    size="small"
                                    name="ipAddress"
                                    type="number"
                                    value={
                                      clause.brokerageConfigurations.minAmount
                                    }
                                    onChange={(event) => {
                                      var value = parseInt(event.target.value);
                                      if (value < 0) value = 0;
                                      // event.target.value = String(value);
                                      setbrokerageMinAmount(
                                        isNaN(value) ? null : value,
                                        index
                                      );
                                    }}
                                  />
                                </TableCell>

                                <TableCell>
                                  <TextField
                                    label="Max Amount"
                                    sx={{ width: '100%' }}
                                    size="small"
                                    name="ipAddress"
                                    type="number"
                                    value={
                                      clause.brokerageConfigurations.maxAmount
                                    }
                                    onChange={(event) => {
                                      var value = parseInt(event.target.value);
                                      if (value < 0) value = 0;
                                      // event.target.value = String(value);

                                      setbrokerageMaxAmount(
                                        isNaN(value) ? null : value,
                                        index
                                      );
                                    }}
                                  />
                                </TableCell>
                              </TableRow>
                              // </form>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  )}
                </CardContent>
                <Grid container mt={1} mb={1} mr={1} ml={1}>
                  <Grid item xs={4}></Grid>
                  <Grid
                    item
                    justifyContent="space-between"
                    alignItems="right"
                    xs={8}
                  >
                    {/* <Button variant="contained" onClick={saveBrokerage}>
                      Save
                    </Button>{' '} */}
                    <LoadingButton
                      sx={{ mt: { xs: 2, md: 0 } }}
                      loading={buttonLoader}
                      variant="contained"
                      type="button"
                      onClick={saveBrokerage}
                    >
                      Save
                    </LoadingButton>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <Button
                      variant="contained"
                      color="error"
                      onClick={() => closeCreateEditForm(false)}
                    >
                      Cancel
                    </Button>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          </Grid>
        ) : (
          <NoPermissionContent />
        )}
      </Container>
    </>
  );
}

export default CreatEdit;
